import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../app/_guard/auth.guard';

import { SigninComponent } from './Auth/signin/signin.component';
import { ChangepasswordComponent } from './Auth/changepassword/changepassword.component';
import { DashboardComponent } from './Pages/dashboard/dashboard.component';
import { ProfileComponent } from './Pages/profile/profile.component';
import { UserListComponent } from './Pages/user-list/user-list.component';
import { StaticListComponent } from './Pages/static-list/static-list.component';
import { StaticEditComponent } from './Pages/static-edit/static-edit.component';
import { SinglecontentlistComponent } from './Pages/singlecontentlist/singlecontentlist.component';
import { ProgramlistComponent } from './Pages/programlist/programlist.component';
import { AlbumlistComponent } from './Pages/albumlist/albumlist.component';
import { UserDetailComponent } from './Pages/user-detail/user-detail.component';
import { AlbumProgramDetailComponent } from './Pages/album-program-detail/album-program-detail.component';
import { CommanListComponent } from './Pages/comman-list/comman-list.component';
import { CommanAddEditComponent } from './Pages/comman-add-edit/comman-add-edit.component';
import { FaqlistComponent } from './Pages/faqlist/faqlist.component';
import { FaqAddEditComponent } from './Pages/faq-add-edit/faq-add-edit.component';
import { ContentDetailComponent } from './Pages/content-detail/content-detail.component';
import { ReferalListComponent } from './Pages/referal-list/referal-list.component';
import { ContactListComponent } from './Pages/contact-list/contact-list.component';
import { CustomerDetailComponent } from './Pages/customer-detail/customer-detail.component';
import { MasterListComponent } from './Pages/master-list/master-list.component';
import { DeletedUserComponent } from './Pages/deleted-user/deleted-user.component';
import { CollabratorComponent } from './Pages/collabrator/collabrator.component';
import { ReportsComponent } from './Pages/reports/reports.component';
import { AppVersionComponent } from './Pages/app-version/app-version.component';
import { TransactionComponent } from './Pages/transaction/transaction.component';
import { WebMediaComponent } from './Pages/web-media/web-media.component';



const routes: Routes = [
  {path:'',component:SigninComponent ,canActivate: [AuthGuard] },
  {path:'signin',component:SigninComponent ,canActivate: [AuthGuard] },
  {path:'reset-password',component:ChangepasswordComponent ,canActivate: [AuthGuard] },
  {path:'dashboard',component:DashboardComponent ,canActivate: [AuthGuard] },
  {path:'profile',component:ProfileComponent ,canActivate: [AuthGuard] }, 
  {path:'users',component:UserListComponent ,canActivate: [AuthGuard] },
  {path:'organisations',component:UserListComponent ,canActivate: [AuthGuard] },
  {path:'creators',component:UserListComponent ,canActivate: [AuthGuard] },
  {path:'static-page',component:StaticListComponent ,canActivate: [AuthGuard] }, 
  {path:'update-static',component:StaticEditComponent ,canActivate: [AuthGuard] },  
  {path:'album-detail',component:AlbumProgramDetailComponent ,canActivate: [AuthGuard] },
  {path:'program-detail',component:AlbumProgramDetailComponent ,canActivate: [AuthGuard] },
  {path:'user-detail',component:CustomerDetailComponent ,canActivate: [AuthGuard] },
  {path:'organisation-detail',component:UserDetailComponent ,canActivate: [AuthGuard] },
  {path:'creator-detail',component:UserDetailComponent ,canActivate: [AuthGuard] },
  {path:'albums',component:AlbumlistComponent ,canActivate: [AuthGuard] },  
  {path:'programs',component:ProgramlistComponent ,canActivate: [AuthGuard] },
  {path:'single-content',component:SinglecontentlistComponent ,canActivate: [AuthGuard] },

  {path:'ability',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-ability',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-ability',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'primary-category',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-primary-category',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-primary-category',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'content-piller',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-content-piller',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-content-piller',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'primary-piller',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-primary-piller',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-primary-piller',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'race',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-race',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-race',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'level',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-level',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-level',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'faq',component:FaqlistComponent ,canActivate: [AuthGuard] },
  {path:'add-faq',component:FaqAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-faq',component:FaqAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-faqs',component:FaqAddEditComponent ,canActivate: [AuthGuard] },

  {path:'medical',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-medical',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-medical',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'location',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-location',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-location',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'suitability',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-suitability',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-suitability',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'suitability',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-suitability',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-suitability',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'subcategory',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-subcategory',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-subcategory',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'diet',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-diet',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-diet',component:CommanAddEditComponent ,canActivate: [AuthGuard] },


  {path:'cookingtime',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-cookingtime',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-cookingtime',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'reasons',component:CommanListComponent ,canActivate: [AuthGuard] },
  {path:'add-reason',component:CommanAddEditComponent ,canActivate: [AuthGuard] },
  {path:'edit-reason',component:CommanAddEditComponent ,canActivate: [AuthGuard] },

  {path:'post-detail',component:ContentDetailComponent ,canActivate: [AuthGuard] },  
  {path:'referal',component:ReferalListComponent ,canActivate: [AuthGuard] },
  
  {path:'reset-link',component:ContactListComponent ,canActivate: [AuthGuard] },


  {path:'demographic',component:MasterListComponent ,canActivate: [AuthGuard] },
  {path:'deleted-user',component:DeletedUserComponent ,canActivate: [AuthGuard] },
  {path:'collabrator',component:CollabratorComponent ,canActivate: [AuthGuard] },

  {path:'report',component:ReportsComponent ,canActivate: [AuthGuard] },
  {path:'feedback',component:ReportsComponent ,canActivate: [AuthGuard] },
  {path:'app-version',component:AppVersionComponent ,canActivate: [AuthGuard]},
  {path:'transaction',component:TransactionComponent ,canActivate: [AuthGuard] },
  {path:'web-media',component:WebMediaComponent ,canActivate: [AuthGuard] },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
